import React from 'react';
import { Spinner } from 'reactstrap';

export default function Loader(props: { size?: string; color?: string; className?: string }) {
    return <Spinner type="grow" size={props.size || 'sm'} color={props.color || 'white'} className={props.className} />;
}
